// extracted by mini-css-extract-plugin
module.exports = {"monthWrapper__nav_next":"monthWrapper__nav_next-1CF0X","monthWrapperrapper__nav_prev":"monthWrapperrapper__nav_prev-3sDGc"};